import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';
import { crmAuth } from '../auth/crm-auth';

const API_URL = import.meta.env.VITE_API_URL || 'https://roniapi.data-corner.com.au';

// Create axios instance for CRM portal API calls
const crmApiClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add CRM auth token
crmApiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const token = crmAuth.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
crmApiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    console.error('CRM API Error:', error.response?.status, error.response?.data);

    if (error.response?.status === 401) {
      // Token expired or invalid - sign out and redirect to CRM login
      await crmAuth.signOut();
      window.location.href = '/crm';
    }

    return Promise.reject(error);
  }
);

export { crmApiClient };
export default crmApiClient;
